export default "__VITE_ASSET__Bv9j576L__"